import { render } from "./DisconnectErrorPage.vue?vue&type=template&id=a172bbee&scoped=true"
const script = {}

import "./DisconnectErrorPage.vue?vue&type=style&index=0&id=a172bbee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a172bbee"]])

export default __exports__